import SectionHeading from '@/components/base/SectionHeading';
import Reveal from '@/components/base/Reveal';
import { firstTrade } from '@/mocks/launch';

export default function FirstTrade() {
  return (
    <section className="w-full bg-foreground-950 py-16 md:py-24">
      <div className="max-w-6xl mx-auto px-4 md:px-6">
        <Reveal>
          <SectionHeading
            dark
            eyebrow="首笔交易"
            title="验证「数字货架 + ePin + 数字消费 + 智能清分」闭环"
            subtitle={firstTrade.desc}
          />
        </Reveal>

        <div className="mt-12 grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-5 gap-4">
          {firstTrade.steps.map((step, i) => (
            <Reveal key={step.label} delay={i * 80}>
              <div className="relative h-full p-5 rounded-lg bg-foreground-900 border border-foreground-700 flex flex-col items-center text-center">
                <div className="w-11 h-11 rounded-full bg-accent-500/20 flex items-center justify-center">
                  <i className={`${step.icon} text-accent-300 text-xl`}></i>
                </div>
                <div className="mt-3 font-heading font-bold text-sm text-background-50 whitespace-nowrap">
                  {step.label}
                </div>
                <p className="mt-2 text-xs text-foreground-400 leading-relaxed">{step.desc}</p>
                {i < firstTrade.steps.length - 1 && (
                  <div className="hidden lg:block absolute top-1/2 -right-4 -translate-y-1/2 text-foreground-600">
                    <i className="ri-arrow-right-line text-lg"></i>
                  </div>
                )}
              </div>
            </Reveal>
          ))}
        </div>
      </div>
    </section>
  );
}